// NOTE: Example for extending Theme: https://codesandbox.io/p/sandbox/romantic-gould-sbkc08?file=%2Fsrc%2Fdeclaration.d.ts%3A45%2C1

interface ExtraPaletteColor {
  darkest: string
  medium: string
  lightest: string
}

interface ExtraPalette {
  neutral: {
    black: string
    darkest: string
    dark: string
    main: string
    mainLight: string
    light: string
    lightest: string
    white: string
  }
}

declare module '@mui/material/styles/createPalette' {
  export interface PaletteColor extends ExtraPaletteColor {}

  // This controls what appears when you use the theme variable inside sx, styled, etc.
  export interface Palette extends ExtraPalette {}
  // This controls what you are allowed to specify in `createTheme`.
  export interface PaletteOptions extends ExtraPalette {}
  // You need both to get the behavior you want.
}

const palette = {
  primary: {
    darkest: '#CBA301',
    dark: '#E7B800',
    main: '#FFCC00',
    medium: '#FFFBF6',
  },
  neutral: {
    black: '#121212',
    darkest: '#343434',
    dark: '#4D4C4C',
    main: '#969594',
    mainLight: '#C2C2C0',
    light: '#EFEFED',
    lightest: '#F7F7F5',
    white: '#FFFFFF',
  },
  error: {
    dark: '#4A0D00',
    main: '#E76245',
    light: '#FFE0E0',
    lightest: '#FEF7F5',
  },
  warning: {
    dark: '#BE6904',
    main: '#EF8F1E',
    light: '#FFF1E0',
    lightest: '#FFFBF6',
  },
  info: {
    dark: '#7A69DE',
    main: '#8C7BF2',
    light: '#E5E0FF',
    lightest: '#FBFAFF',
  },
  success: {
    dark: '#67A586',
    main: '#75D7A6',
    light: '#E0FFF0',
    lightest: '#F7FCF9',
  },
}

export default palette
